{% block sw_product_seo_form %}
    <sw-container rows="auto auto">
        <sw-card-section divider="bottom">
            {% parent %}
        </sw-card-section>
        <sw-card-section>
            <div>{{ $tc('hueb-seo.general.labelSerp') }}</div><br>
            <div class="hueb-seo__preview">
                <span class="hueb-seo__metaTitle">{{ metaTitlePreview }}</span><br>
                <span class="hueb-seo__seoUrl">{{ seoUrl }}</span><br>
                <span class="hueb-seo__metaDescription">{{ metaDescriptionPreview }}</span><br>
            </div>
        </sw-card-section>
    </sw-container>
{% endblock %}

{% block sw_product_seo_form_meta_title %}
    <sw-inherit-wrapper
        v-model:value="product.metaTitle"
        :has-parent="hasParent"
        :label="$tc('hueb-seo.general.empty')"
        :help-text="$tc('sw-product.seoForm.helpTextMetaTitle')"
        :inherited-value="parentProduct.metaTitle"
    >
        <template #content="props">
            <div class="sw-inherit-wrapper__toggle-wrapper">
                <label class="sw-inherit-wrapper__inheritance-label">
                    {{ $tc('sw-product.seoForm.labelMetaTitle') }}
                    <span class="hueb-seo__wordCount" v-bind:class="{ active: metaTitleColor }">{{ metaTitleCount }}</span>
                </label>
            </div>
            <mt-text-field
                :placeholder="$tc('sw-product.seoForm.placeholderMetaTitle')"
                :error="productMetaTitleError"
                :disabled="props.isInherited || !allowEdit"
                v-model="props.currentValue"
                @update:model-value="props.updateCurrentValue"
            />
        </template>
    </sw-inherit-wrapper>
{% endblock %}

{% block sw_product_seo_form_meta_description %}
    <sw-inherit-wrapper
        v-model:value="product.metaDescription"
        :has-parent="hasParent"
        :label="$tc('hueb-seo.general.empty')"
        :help-text="$tc('sw-product.seoForm.helpTextMetaDescription')"
        :inherited-value="parentProduct.metaDescription">
        <template #content="props">
            <div class="sw-inherit-wrapper__toggle-wrapper">
                <label class="sw-inherit-wrapper__inheritance-label">
                    {{ $tc('sw-product.seoForm.labelMetaDescription') }}
                    <span class="hueb-seo__wordCount" v-bind:class="{ active: metaDescriptionColor }">{{ metaDescriptionCount }}</span>
                </label>
            </div>

            <mt-textarea
                :placeholder="$tc('sw-product.seoForm.placeholderMetaDescription')"
                :error="productMetaDescriptionError"
                :disabled="props.isInherited || !allowEdit"
                :model-value="props.currentValue"
                @update:model-value="props.updateCurrentValue"
            />
        </template>
    </sw-inherit-wrapper>
{% endblock %}

{% block sw_product_seo_form_keywords %}
    <sw-inherit-wrapper
        v-model:value="product.keywords"
        :has-parent="hasParent"
        :label="$tc('hueb-seo.general.empty')"
        :help-text="$tc('sw-product.seoForm.helpTextKeywords')"
        :inherited-value="parentProduct.keywords">
        <template #content="props">
            <div class="sw-inherit-wrapper__toggle-wrapper">
                <label class="sw-inherit-wrapper__inheritance-label">
                    {{ $tc('sw-product.seoForm.labelKeywords') }}
                </label>
            </div>

            <mt-text-field
                :placeholder="$tc('sw-product.seoForm.placeholderKeywords')"
                :error="productKeywordsError"
                :disabled="props.isInherited || !allowEdit"
                v-model="props.currentValue"
                @update:model-value="props.updateCurrentValue"
            />
        </template>
    </sw-inherit-wrapper>
{% endblock %}

